import { Device } from 'DeviceUtils';
import { Dimensions, PixelRatio, StyleSheet } from 'react-native';
import Theme from 'Theme';

const isLong = Dimensions.get('window').height > 800;
const consentsStyle = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
    },
    webContainer: {
        width: '50%',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.9)'
    },
    backgroundImage: {
        flex: 1,
        resizeMode: 'cover'
    },
    overlayMobile: {
        width: '91.9%',
        position: 'absolute',
        paddingVertical: isLong ? 40 : '4.3%',
        paddingHorizontal: '2.7%',
        backgroundColor: '#000'
        // borderWidth: 0.3,
        // borderColor: 'white'
    },
    overlayTablet: {
        position: 'absolute',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        width: '62.5%',
        paddingVertical: '9%',
        paddingHorizontal: '5%',
        margin: 20,
        alignItems: 'center',
        justifyContent: 'center'
    },
    overlayWeb: {
        width: '50%',
        alignItems: 'center',
        justifyContent: 'center',
        alignContent: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        paddingVertical: '5%',
        paddingHorizontal: '5%'
        // padding: 40,
        // margin: 20
    },
    contentContainer: {
        flex: 1,
        alignItems: 'center',
        paddingHorizontal: '2.9%'
    },
    badgePhone: {
        height: 70,
        width: '65%',
        marginBottom: isLong ? 5 : '4.2%',
        resizeMode: 'contain'
        // width: '95%',
        // height: '17.8%',
    },
    badge: {
        top: -160 / 2,
        right: -160 / 2,
        position: 'absolute',
        width: 190,
        height: 190
    },
    logo: {
        height: Device.isPhone ? 50 : '20%',
        width: Device.isPhone ? '54%' : '42%',
        marginBottom: isLong ? 5 : '4.2%',
        resizeMode: 'contain'
    },
    webLogo: {
        height: '30%',
        width: '50%',
        marginBottom: '4.2%',
        resizeMode: 'contain'
    },
    title: {
        width: Device.isTabletOrWeb ? '80%' : 'auto',
        marginBottom: isLong ? 23 : '4.2%',
        textAlign: 'center',
        fontSize: Device.isWeb ? 23 : 22,
        fontFamily: Theme.boldFont,
        color: '#fcfcfc'
    },
    description: {
        // color: '#fcfcfc',
        // paddingBottom: Device.isTabletOrWeb ? 20 : 30,
        // marginBottom: isLong ? 23 : '4.2%',
        // textAlign: 'center',
        // color: Theme.primaryTextColor,
        // fontFamily: Theme.regularFont,
        // fontSize: Theme.fontSizes.description,
        // fontWeight: '300'
    },
    tabletDescription: {
        paddingBottom: 5,
        marginBottom: '4.2%',
        textAlign: 'center',
        color: Theme.primaryTextColor,
        fontFamily: Theme.regularFont,
        fontSize: 22,
        fontWeight: '300'
    },
    divider: {
        height: 1,
        width: '100%',
        marginBottom: isLong ? 23 : '4.2%',
        backgroundColor: 'rgba(255, 255, 255, 0.3)'
    },
    buttonContainer: {
        flexDirection: 'column'
    },
    buttonDetailed: {
        flex: 1,
        borderWidth: 1,
        borderColor: 'rgba(255, 255, 255, 0.3)',
        paddingVertical: 14,
        borderRadius: 3,
        marginVertical: 15,
        fontFamily: Theme.regularFont,
        fontWeight: '400',
        justifyContent: 'center',
        paddingHorizontal: 20
    },
    buttonContainerText: {
        flex: Device.isWeb ? 1 : 0
    },
    buttonText: {
        color: 'white',
        fontSize: Device.isTabletOrWeb ? 22 : 18,
        textAlign: 'center',
        fontWeight: '300'
        // letterSpacing: 1.5
    },
    alignmentsOnWebOrTablet: {
        flexDirection: 'row',
        gap: Theme.primaryMargin
        // flex: Device.isWeb ? 0 : 1,
        // flexGrow: 0,
        // flexShrink: 0,
        // justifyContent: 'center',
        // gap: 50
        // width: '70%'
        // margin: 8,
    },
    button: {
        minWidth: 0,
        paddingHorizontal: Theme.BU * 2,
        // borderRadius: 8,
        borderRadius: 3,
        fontSize: 30
    },
    cancelButton: {
        backgroundColor: Theme.secondaryBackgroundColor,
        borderColor: Theme.secondaryButtonBorderColor
    }
});

export default consentsStyle;
